import { Suspense } from 'react';
import { Link, Routes, Route, Outlet, useLocation } from 'react-router-dom';
import { Box, Tab, Tabs } from '@mui/material';
import { useTranslation } from 'react-i18next';

import OverLayLoader from '../components/OverLayLoader';
import ClassificationView from './subviews/functions/ClassificationView';
import MatchingView from './subviews/functions/MatchingView';
import MatchingResultView from './subviews/functions/MatchingResultView';
import ClassificationResultView from './subviews/functions/ClassificationResultView';
import PATH from '../helpers/routes.json';

const FunctionsView = () => {
  const { t } = useTranslation(['common']);
  const { pathname } = useLocation();

  const currentTab = Object.values(PATH.functions.tabs).find(tabPath =>
    pathname.startsWith(tabPath),
  );

  return (
    <Box>
      <Tabs
        value={currentTab || false}
        textColor="primary"
        indicatorColor="primary"
        aria-label="Functions"
      >
        {Object.keys(PATH.functions.tabs).map(tab => (
          <Tab
            key={tab}
            value={PATH.functions.tabs[tab]}
            label={t(`pages.functions.tabs.${tab}`)}
            component={Link}
            to={PATH.functions.tabs[tab]}
          />
        ))}
      </Tabs>

      <Box pt={3} px={15}>
        <Suspense fallback={<OverLayLoader />}>
          <Routes>
            <Route path="/" element={<Outlet />}>
              <Route path="classification" element={<ClassificationView />} />
              <Route
                path="classification/:taskId"
                element={<ClassificationResultView />}
              />
              <Route path="matching" element={<MatchingView />} />
              <Route path="matching/:taskId" element={<MatchingResultView />} />
            </Route>
          </Routes>
        </Suspense>
      </Box>
    </Box>
  );
};

export default FunctionsView;
